import React from 'react';
import classNames from 'classnames';
import { ErrorMessage, Field } from 'formik';

import { formStyles } from '../../lib/constants/SiteVariables';

export default function StickySelect({
  disclaimer,
  error,
  id,
  options,
  placeholder,
  touched,
  values
}) {

  const field = id.includes('.') && id.split('.');
  const fieldComplete = field ? values[field[0]][field[1]] : values[id]

  return (
    <div className="select">
      <div className="form-floating flex flex-col outline relative">
        <Field
          as="select"
          className={classNames(
            'w-full px-3.5 pt-[1.6rem] pb-3 block w-full mt-0 bg-transparent text-navy-blue border border-solid border-opaque-navy-border block rounded-lg appearance-none focus:outline-none focus:ring-0',
            formStyles.error(touched && error),
          )}
          children={options.map((o) => (
            <option key={o[1]} value={o[1]}>
              {o[0]}
            </option>
          ))}
          id={id}
          name={id}
        />
        <label
          className={classNames(
            'text-light-gray absolute duration-300 top-[1.4rem] -z-1 origin-0 px-3.5',
            { uppercase: fieldComplete },
          )}
          htmlFor={id}
        >
          {placeholder}
        </label>
        {disclaimer && disclaimer}
        <ErrorMessage
          name={id}
          component="div"
          className={formStyles.validation}
        />
      </div>
    </div>
  );
}
